// extracted by mini-css-extract-plugin
module.exports = {"link":"_31hZA","image":"-sXIe","root":"u6LZO"};